import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from '../storage.service';
import { AbstractApiService } from './abstract-api.service';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import {
  SiteAddEditApiRequest,
  SiteAddUserApiRequest,
  SiteApiPostResponseData,
  SiteListApiResponse,
} from '@reenstudio/app/core/models/api/site/site-api-model';
import { Site } from '../../models/site/site';

@Injectable({
  providedIn: 'root',
})
export class SiteApiService extends AbstractApiService {
  private readonly endpoint = '/sites';

  constructor(
    protected override http: HttpClient,
    protected override logger: NGXLogger,
  ) {
    super(http, logger);
  }

  getSites(params?: {
    siteId?: number;
    siteName?: string;
    enabled?: boolean;
    page?: number;
    pageSize?: number;
  }) {
    return this.fetch<SiteListApiResponse>(`${this.endpoint}`, params, true);
  }

  getSite(id: number) {
    return this.fetch<Site>(`${this.endpoint}/${id}`);
  }

  addSite(data: SiteAddEditApiRequest): Observable<SiteApiPostResponseData> {
    return this.post<SiteAddEditApiRequest, SiteApiPostResponseData>(
      `${this.endpoint}`,
      data,
    );
  }

  addSiteUser(userId: string, params: SiteAddUserApiRequest) {
    return this.post<SiteAddUserApiRequest, string>(
      `/users/${userId}/site`,
      params,
    );
  }

  editSite(id: number, data: SiteAddEditApiRequest) {
    return this.patch<SiteAddEditApiRequest, string>(
      `${this.endpoint}/${id}`,
      data,
    );
  }

  deleteSite(siteId: number) {
    return this.delete<SiteAddUserApiRequest>(`${this.endpoint}/${siteId}`);
  }

  deleteSiteUser(userId: string, params: SiteAddUserApiRequest) {
    return this.delete<SiteAddUserApiRequest>(`/users/${userId}/site`, params);
  }
}
